import { closest } from "./jQueryShim";

export function getScrollingElement(childEl?: Element): HTMLElement | null {
	if (childEl) {
		return closest(childEl, ".app-main");
	}
	return document.querySelector(".app-main");
}
